import React from "react";
import { useSnackbarMessage } from "../../../Snackbar";
import { createEditedAppointmentNote } from "../../../../services/api";
import InlineNoteEditor from "./InlineNoteEditor";
import * as api from "../../../../services/api";
import { useLatest } from "../../../../hooks";
import { useCurrentLocation } from "../../../../context/LocationContext";

function useServiceOptions(client_id) {
  const location = useCurrentLocation();
  const [options, setOptions] = React.useState();
  const res = React.useMemo(
    () => ({ options: options ?? [], loading: options == null }),
    [options],
  );

  useLatest(
    async (signal) => {
      setOptions(null);
      const result = await api.loadReservableServices(
        {
          filter: {
            visible: { eq: true },
            create_reservation: { eq: true },
            product: {
              client_id: { eq: client_id },
              company_id: { eq: location.company_id },
            },
          },
        },
        { signal },
        api.contextFromLocation(location.id),
      );
      setOptions(result.data.services.data);
    },
    [location, client_id],
  );

  return res;
}

export default function ReceptionNote({
  entry,
  selectedVersions,
  fetchTimeline,
  canEdit,
  clientId,
}) {
  const serviceOptionsData = useServiceOptions(clientId);
  const displaySnackbarMessage = useSnackbarMessage();

  const versions = entry.versions || [];
  const selId =
    selectedVersions[entry.id] ||
    (versions.find((v) => v.is_latest)?.version_id ??
      versions[versions.length - 1]?.version_id);
  const selectedNoteVersion =
    versions.find((v) => v.version_id === selId) ||
    versions[versions.length - 1] ||
    null;

  const entryForEditor = selectedNoteVersion
    ? {
        ...entry,
        note: selectedNoteVersion.note_content,
        doctor_required: selectedNoteVersion.doctor_required,
        service_id: selectedNoteVersion.service_id,
        reservation_count: selectedNoteVersion.reservation_count,
        reservation_unit: selectedNoteVersion.reservation_unit,
      }
    : entry;

  return (
    <InlineNoteEditor
      entry={entryForEditor}
      selectedNoteVersion={
        selectedNoteVersion || {
          note_content: entry.note,
        }
      }
      canEdit={canEdit && (selectedNoteVersion?.is_editable ?? true)}
      showEditButton={!!(selectedNoteVersion?.is_latest ?? true)}
      serviceOptionsData={serviceOptionsData}
      onSave={async (formData) => {
        await createEditedAppointmentNote({
          previous_id: selectedNoteVersion?.version_id || entry.id,
          input: {
            note_content: formData.note_content?.trim() || "",
            doctor_required:
              typeof formData.doctor_required === "boolean"
                ? formData.doctor_required
                : null,
            service_id: formData.service_id || null,
            reservation_count:
              formData.reservation_count !== undefined &&
              formData.reservation_count !== null &&
              formData.reservation_count !== ""
                ? Number(formData.reservation_count)
                : null,
            reservation_unit: formData.reservation_unit || null,
          },
        });
        fetchTimeline();
        displaySnackbarMessage({
          title: "Editace poznámky proběhla úspěšně.",
          content: "",
        });
      }}
    />
  );
}
